import { action } from 'satcheljs';

export interface OnCopilotChatDrawerOpenedMessage {
    targetWindow: Window;
}

// Dispatched specifically when the Copilot Chat Drawer is opened
export const onCopilotChatDrawerOpened: (targetWindow: Window) => OnCopilotChatDrawerOpenedMessage =
    action(
        'onCopilotChatDrawerOpened',
        (targetWindow: Window): OnCopilotChatDrawerOpenedMessage => ({
            targetWindow,
        })
    );
